import { useEffect, useState } from 'react'
import { onValue, ref } from 'firebase/database'
import { db, tref } from '../lib/firebase.js'

// Fixed top banner shown when the app is not connected to the Realtime
// Database (.info/connected). At the venue this gives staff a clear "you're
// offline / reconnecting" signal instead of silent empty rosters and dropdowns.
// It stays hidden during the brief initial connect (a 5s grace) so it doesn't
// flash on every load; if we STILL haven't connected after that (the venue
// "never connects" case) it appears, and it also appears if we connect and
// later drop.
export default function OfflineBanner() {
  const [connected, setConnected] = useState(true)
  const [everConnected, setEverConnected] = useState(false)
  const [graceOver, setGraceOver] = useState(false)

  useEffect(() => {
    const t = setTimeout(() => setGraceOver(true), 5000)
    let off
    try {
      off = onValue(
        tref('.info/connected'),
        (snap) => {
          const c = snap.val() === true
          setConnected(c)
          if (c) setEverConnected(true)
        },
        () => {},
      )
    } catch { /* ignore */ }
    return () => { clearTimeout(t); if (off) off() }
  }, [])

  if (connected) return null
  // Don't flash during the very first connect.
  if (!everConnected && !graceOver) return null

  return (
    <div
      role="alert"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 2147483001,
        background: '#B10C0C', color: '#FFFFFF', textAlign: 'center',
        padding: '6px 12px', fontSize: 13, fontWeight: 700, letterSpacing: '0.02em',
        boxShadow: '0 2px 10px rgba(0,0,0,0.35)',
      }}>
      ⚠ Reconnecting… you’re offline. Data may be out of date.
    </div>
  )
}
